import { Outlet, Link } from "react-router-dom";
import { useAuth } from "@flame/shared/auth";

/**
 * Top-level layout for authenticated pages.
 * Shows a header with brand, user name, and logout button.
 * Renders child routes via <Outlet />.
 */
export function AppShell() {
  const { me, logout } = useAuth();

  const displayName =
    me?.user.first_name ??
    me?.user.username ??
    `tg:${String(me?.user.tg_id ?? "")}`;

  return (
    <div className="min-h-screen bg-bg text-fg">
      <header className="border-b border-border bg-surface px-4 py-3">
        <div className="mx-auto flex max-w-4xl items-center justify-between">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            FlameVPN
          </Link>
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted">{displayName}</span>
            <button
              onClick={() => void logout()}
              className="text-sm text-muted transition-colors hover:text-fg"
            >
              Выйти
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
